import EventSessionListActionTypes from './event-session-list-action-types';
import ValidationError from '../../../utils/validation-error';

export const findSessions = (payload) => async(dispatch, getState, { api }) => {
  dispatch({ type: EventSessionListActionTypes.LOAD_EVENT_SESSION_LIST_START });
  const state = getState().generalCompetencyEventSessionList;
  const query = {
    skip: payload.skip != null ? payload.skip : state.skip,
    limit: payload.take != null ? payload.take : state.take
  };
  try {
    const result = await api.get(`api/general_competency_events/${payload.eventId}/sessions`, query);
    const sessions = result ? result.data.map(s => ({
      ...s,
      startAt: s.startAt ? new Date(s.startAt) : null
    })) : [];
    dispatch({
      type: EventSessionListActionTypes.LOAD_EVENT_SESSION_LIST_END,
      payload: {
        sessions,
        total: result ? result.total : 0,
        skip: query.skip,
        take: query.limit
      }
    });
  } catch (error) {
    dispatch({ type: EventSessionListActionTypes.LOAD_EVENT_SESSION_LIST_END });
    throw error;
  }
};

export const openSessionConfirmDialog = (payload) => async(dispatch) => {
  dispatch({
    type: EventSessionListActionTypes.TOGGLE_EVENT_SESSION_LIST_CONFIRM_DIALOG,
    payload: payload
  });
};

export const closeSessionConfirmDialog = () => async(dispatch) => {
  dispatch({ type: EventSessionListActionTypes.TOGGLE_EVENT_SESSION_LIST_CONFIRM_DIALOG });
};

export const removeSessionConfirmDialog = ({ eventId }) => async(dispatch, getState, { api }) => {
  const state = getState().generalCompetencyEventSessionList;
  if (state.selectedSessionId > 0) {
    try {
      await api.remove(`api/general_competency_events/${eventId}/sessions/${state.selectedSessionId}`);
      dispatch(findSessions({ eventId }));
      dispatch({ type: EventSessionListActionTypes.TOGGLE_EVENT_SESSION_LIST_CONFIRM_DIALOG });
    } catch (error) {
      if (error instanceof ValidationError) {
        dispatch({ type: EventSessionListActionTypes.SET_CONFIRM_DIALOG_ERROR, payload: { errorMessage: error.message } });
      }
    }
  } else {
    dispatch({ type: EventSessionListActionTypes.TOGGLE_EVENT_SESSION_LIST_CONFIRM_DIALOG });
  }
};
